import { render, staticRenderFns } from "./SelectTeamModal.vue?vue&type=template&id=13aaec23&"
import script from "./SelectTeamModal.vue?vue&type=script&lang=js&"
export * from "./SelectTeamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports